import type { AnnouncementRequest, AppType } from '@/api/announcements'

export const APP_TYPE_OPTIONS: {
  value: AppType
  label: string
  description: string
}[] = [
  { value: 'lc', label: '러닝센터 B2B', description: '센터 관리자·학습자 대상' },
  { value: 'company', label: '기업 B2B', description: '기업 관리자·학습자 대상' },
  { value: 'b2c', label: 'B2C', description: '개인 학습자 대상' },
]

export const DEFAULT_APP_TYPE: AppType = APP_TYPE_OPTIONS[0].value

export function parseAppType(value: string | null): AppType {
  return APP_TYPE_OPTIONS.some(option => option.value === value)
    ? value as AppType
    : DEFAULT_APP_TYPE
}

export function getSelectedAppType(
  targetAppTypes: AppType[] | undefined,
  fallback: AppType,
): AppType {
  return targetAppTypes?.[0] ?? fallback
}

export function changeAnnouncementTargetApp(
  current: AnnouncementRequest,
  nextAppType: AppType,
): AnnouncementRequest {
  return {
    ...current,
    targetAppTypes: [nextAppType],
    targetOrganizationIds: [],
    targetAudience: nextAppType === 'b2c' ? null : current.targetAudience,
    isGlobal: nextAppType === 'b2c' ? true : current.isGlobal,
  }
}
